import { FormGroup } from '@angular/forms';

/**
 * Gets a value of a control from a form. Returns null when the form is null
 * @param formControlname 
 * @param form 
 */
export function getValue(formControlname: string, form: FormGroup) {
    if (!form) { 
        return null;
    }
    let control = form.get(formControlname);
    if (!control) {
        throw new Error(`The form doesn't have a control with name ${formControlname}.`);
    }
    return control.value;
}

export function setValue(formControlName: string, value: any, form: FormGroup) {
    form.get(formControlName).setValue(value);
    form.get(formControlName).markAsDirty();
}

export function setNull(formControlName: string, form: FormGroup) {
    form.get(formControlName).setValue(null);
    form.get(formControlName).markAsDirty();
}

export function setNullAndDisable(formControlName: string, form: FormGroup) {
    form.get(formControlName).setValue(null);
    form.get(formControlName).markAsDirty();
    form.get(formControlName).disable();
}

export function setNullAndEnable(formControlName: string, form: FormGroup) {
    form.get(formControlName).setValue(null);
    form.get(formControlName).markAsDirty();
    form.get(formControlName).enable();
}